module.exports = __webpack_public_path__ + "static/media/01.99d0c339.jpg";